export enum InitiatorType {
    System = 'system',
    API = 'api',
    Customer = 'customer',
    BackOfficeUser = 'back-office-user',
    BrokerUser = 'partner-user',
    BrokerApi = 'broker-api',
    Anonymous = 'anonymous-user'
  }